import React from 'react';
import './CustomTabs.css';

interface TabItem {
  key: string;
  label: string;
}

interface CustomTabsProps {
  tabs: TabItem[];
  activeKey: string;
  onSelect: (key: string) => void;
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, activeKey, onSelect, orientation = 'horizontal', className }) => {
  return (
    <div className={`custom-tabs ${orientation} ${className || ''}`.trim()}>
      {tabs.map(tab => (
        <div
          key={tab.key}
          className={`custom-tab${activeKey === tab.key ? ' active' : ''}`}
          onClick={() => onSelect(tab.key)}
        >
          {tab.label}
          {activeKey === tab.key && <div className={`custom-tab-arrow ${orientation}`} />}
        </div>
      ))}
    </div>
  );
};

export default CustomTabs; 